var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('TheHeader'),_c('TheNavigation'),(!_vm.$route.name.includes('404') && !_vm.$route.name.includes('403'))?_c('TheBreadcrumbs'):_vm._e(),_c('v-layout',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }